import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Field, StyledInput } from 'pages/ManageClubEurostar/ManageClubEurostar.styles';
import Label from 'components/ui/Label';
import { isValidPassengersNumber } from 'utils/validators';
import { PAX_DESCRIPTIONS } from 'constants/booking';

import { AddCompanionsWrapper, StyledDescription } from './AddPassengersCta.styles';

const BlockedSeats = ({ register, errors }) => (
  <AddCompanionsWrapper>
    <Field>
      <Label htmlFor="blockedSeats">
        <FormattedMessage id="addPassengers.adults" />{' '}
        <StyledDescription>
          (<FormattedMessage id={`groupBooking.${PAX_DESCRIPTIONS.adults}`} />)
        </StyledDescription>
      </Label>
      <StyledInput
        {...register('blockedSeats', {
          validate: (value) => !value || isValidPassengersNumber(value)
        })}
        type="number"
        inputMode="numeric"
        id="blockedSeats"
        data-testid="blockedSeats"
        validationState={errors.blockedSeats ? 'error' : ''}
      />
    </Field>
  </AddCompanionsWrapper>
);

BlockedSeats.propTypes = {
  register: PropTypes.func,
  errors: PropTypes.shape({
    blockedSeats: PropTypes.string
  })
};

export default BlockedSeats;
